import { render, staticRenderFns } from "./HouseSidebar.vue?vue&type=template&id=708b5680&"
import script from "./HouseSidebar.vue?vue&type=script&lang=js&"
export * from "./HouseSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HouseSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports